var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;var pug_debug_filename, pug_debug_line;try {var pug_debug_sources = {"\u002Fopt\u002Fgirder\u002Fgirder\u002Fweb_client\u002Fsrc\u002Ftemplates\u002Fwidgets\u002FrootSelectorWidget.pug":"- selected = selected || {id: ''};\nselect#g-root-selector.form-control(required)\n  if !selected.id\n    option(value=\"\", disabled, selected, hidden) Select a root...\n  each groupName in display\n    if groupName === 'Home' && home\n      option(value=home.id, selected=selected.id === home.id) Home\n    else if groupName in groups\n      - var group = groups[groupName];\n      optgroup(label=groupName)\n        each model in group.models\n          if !home || model.id !== home.id\n            option(value=model.id, data-group=groupName, selected=model.id === selected.id)= format(model)\n"};
;var locals_for_with = (locals || {});(function (display, format, groups, home, selected) {;pug_debug_line = 1;pug_debug_filename = "\u002Fopt\u002Fgirder\u002Fgirder\u002Fweb_client\u002Fsrc\u002Ftemplates\u002Fwidgets\u002FrootSelectorWidget.pug";
selected = selected || {id: ''};
;pug_debug_line = 2;pug_debug_filename = "\u002Fopt\u002Fgirder\u002Fgirder\u002Fweb_client\u002Fsrc\u002Ftemplates\u002Fwidgets\u002FrootSelectorWidget.pug";
pug_html = pug_html + "\u003Cselect class=\"form-control\" id=\"g-root-selector\" required\u003E";
;pug_debug_line = 3;pug_debug_filename = "\u002Fopt\u002Fgirder\u002Fgirder\u002Fweb_client\u002Fsrc\u002Ftemplates\u002Fwidgets\u002FrootSelectorWidget.pug";
if (!selected.id) {
;pug_debug_line = 4;pug_debug_filename = "\u002Fopt\u002Fgirder\u002Fgirder\u002Fweb_client\u002Fsrc\u002Ftemplates\u002Fwidgets\u002FrootSelectorWidget.pug";
pug_html = pug_html + "\u003Coption value=\"\" disabled selected hidden\u003E";
;pug_debug_line = 4;pug_debug_filename = "\u002Fopt\u002Fgirder\u002Fgirder\u002Fweb_client\u002Fsrc\u002Ftemplates\u002Fwidgets\u002FrootSelectorWidget.pug";
pug_html = pug_html + "Select a root...\u003C\u002Foption\u003E";
}
;pug_debug_line = 5;pug_debug_filename = "\u002Fopt\u002Fgirder\u002Fgirder\u002Fweb_client\u002Fsrc\u002Ftemplates\u002Fwidgets\u002FrootSelectorWidget.pug";
// iterate display
;(function(){
  var $$obj = display;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var groupName = $$obj[pug_index0];
;pug_debug_line = 6;pug_debug_filename = "\u002Fopt\u002Fgirder\u002Fgirder\u002Fweb_client\u002Fsrc\u002Ftemplates\u002Fwidgets\u002FrootSelectorWidget.pug";
if (groupName === 'Home' && home) {
;pug_debug_line = 7;pug_debug_filename = "\u002Fopt\u002Fgirder\u002Fgirder\u002Fweb_client\u002Fsrc\u002Ftemplates\u002Fwidgets\u002FrootSelectorWidget.pug";
pug_html = pug_html + "\u003Coption" + (pug.attr("value", home.id, true, true)+pug.attr("selected", selected.id === home.id, true, true)) + "\u003E";
;pug_debug_line = 7;pug_debug_filename = "\u002Fopt\u002Fgirder\u002Fgirder\u002Fweb_client\u002Fsrc\u002Ftemplates\u002Fwidgets\u002FrootSelectorWidget.pug";
pug_html = pug_html + "Home\u003C\u002Foption\u003E";
}
else
if (groupName in groups) {
;pug_debug_line = 9;pug_debug_filename = "\u002Fopt\u002Fgirder\u002Fgirder\u002Fweb_client\u002Fsrc\u002Ftemplates\u002Fwidgets\u002FrootSelectorWidget.pug";
var group = groups[groupName];
;pug_debug_line = 10;pug_debug_filename = "\u002Fopt\u002Fgirder\u002Fgirder\u002Fweb_client\u002Fsrc\u002Ftemplates\u002Fwidgets\u002FrootSelectorWidget.pug";
pug_html = pug_html + "\u003Coptgroup" + (pug.attr("label", groupName, true, true)) + "\u003E";
;pug_debug_line = 11;pug_debug_filename = "\u002Fopt\u002Fgirder\u002Fgirder\u002Fweb_client\u002Fsrc\u002Ftemplates\u002Fwidgets\u002FrootSelectorWidget.pug";
// iterate group.models
;(function(){
  var $$obj = group.models;
  if ('number' == typeof $$obj.length) {
      for (var pug_index1 = 0, $$l = $$obj.length; pug_index1 < $$l; pug_index1++) {
        var model = $$obj[pug_index1];
;pug_debug_line = 12;pug_debug_filename = "\u002Fopt\u002Fgirder\u002Fgirder\u002Fweb_client\u002Fsrc\u002Ftemplates\u002Fwidgets\u002FrootSelectorWidget.pug";
if (!home || model.id !== home.id) {
;pug_debug_line = 13;pug_debug_filename = "\u002Fopt\u002Fgirder\u002Fgirder\u002Fweb_client\u002Fsrc\u002Ftemplates\u002Fwidgets\u002FrootSelectorWidget.pug";
pug_html = pug_html + "\u003Coption" + (pug.attr("value", model.id, true, true)+pug.attr("data-group", groupName, true, true)+pug.attr("selected", model.id === selected.id, true, true)) + "\u003E";
;pug_debug_line = 13;pug_debug_filename = "\u002Fopt\u002Fgirder\u002Fgirder\u002Fweb_client\u002Fsrc\u002Ftemplates\u002Fwidgets\u002FrootSelectorWidget.pug";
pug_html = pug_html + (pug.escape(null == (pug_interp = format(model)) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index1 in $$obj) {
      $$l++;
      var model = $$obj[pug_index1];
;pug_debug_line = 12;pug_debug_filename = "\u002Fopt\u002Fgirder\u002Fgirder\u002Fweb_client\u002Fsrc\u002Ftemplates\u002Fwidgets\u002FrootSelectorWidget.pug";
if (!home || model.id !== home.id) {
;pug_debug_line = 13;pug_debug_filename = "\u002Fopt\u002Fgirder\u002Fgirder\u002Fweb_client\u002Fsrc\u002Ftemplates\u002Fwidgets\u002FrootSelectorWidget.pug";
pug_html = pug_html + "\u003Coption" + (pug.attr("value", model.id, true, true)+pug.attr("data-group", groupName, true, true)+pug.attr("selected", model.id === selected.id, true, true)) + "\u003E";
;pug_debug_line = 13;pug_debug_filename = "\u002Fopt\u002Fgirder\u002Fgirder\u002Fweb_client\u002Fsrc\u002Ftemplates\u002Fwidgets\u002FrootSelectorWidget.pug";
pug_html = pug_html + (pug.escape(null == (pug_interp = format(model)) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Foptgroup\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var groupName = $$obj[pug_index0];
;pug_debug_line = 6;pug_debug_filename = "\u002Fopt\u002Fgirder\u002Fgirder\u002Fweb_client\u002Fsrc\u002Ftemplates\u002Fwidgets\u002FrootSelectorWidget.pug";
if (groupName === 'Home' && home) {
;pug_debug_line = 7;pug_debug_filename = "\u002Fopt\u002Fgirder\u002Fgirder\u002Fweb_client\u002Fsrc\u002Ftemplates\u002Fwidgets\u002FrootSelectorWidget.pug";
pug_html = pug_html + "\u003Coption" + (pug.attr("value", home.id, true, true)+pug.attr("selected", selected.id === home.id, true, true)) + "\u003E";
;pug_debug_line = 7;pug_debug_filename = "\u002Fopt\u002Fgirder\u002Fgirder\u002Fweb_client\u002Fsrc\u002Ftemplates\u002Fwidgets\u002FrootSelectorWidget.pug";
pug_html = pug_html + "Home\u003C\u002Foption\u003E";
}
else
if (groupName in groups) {
;pug_debug_line = 9;pug_debug_filename = "\u002Fopt\u002Fgirder\u002Fgirder\u002Fweb_client\u002Fsrc\u002Ftemplates\u002Fwidgets\u002FrootSelectorWidget.pug";
var group = groups[groupName];
;pug_debug_line = 10;pug_debug_filename = "\u002Fopt\u002Fgirder\u002Fgirder\u002Fweb_client\u002Fsrc\u002Ftemplates\u002Fwidgets\u002FrootSelectorWidget.pug";
pug_html = pug_html + "\u003Coptgroup" + (pug.attr("label", groupName, true, true)) + "\u003E";
;pug_debug_line = 11;pug_debug_filename = "\u002Fopt\u002Fgirder\u002Fgirder\u002Fweb_client\u002Fsrc\u002Ftemplates\u002Fwidgets\u002FrootSelectorWidget.pug";
// iterate group.models
;(function(){
  var $$obj = group.models;
  if ('number' == typeof $$obj.length) {
      for (var pug_index2 = 0, $$l = $$obj.length; pug_index2 < $$l; pug_index2++) {
        var model = $$obj[pug_index2];
;pug_debug_line = 12;pug_debug_filename = "\u002Fopt\u002Fgirder\u002Fgirder\u002Fweb_client\u002Fsrc\u002Ftemplates\u002Fwidgets\u002FrootSelectorWidget.pug";
if (!home || model.id !== home.id) {
;pug_debug_line = 13;pug_debug_filename = "\u002Fopt\u002Fgirder\u002Fgirder\u002Fweb_client\u002Fsrc\u002Ftemplates\u002Fwidgets\u002FrootSelectorWidget.pug";
pug_html = pug_html + "\u003Coption" + (pug.attr("value", model.id, true, true)+pug.attr("data-group", groupName, true, true)+pug.attr("selected", model.id === selected.id, true, true)) + "\u003E";
;pug_debug_line = 13;pug_debug_filename = "\u002Fopt\u002Fgirder\u002Fgirder\u002Fweb_client\u002Fsrc\u002Ftemplates\u002Fwidgets\u002FrootSelectorWidget.pug";
pug_html = pug_html + (pug.escape(null == (pug_interp = format(model)) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index2 in $$obj) {
      $$l++;
      var model = $$obj[pug_index2];
;pug_debug_line = 12;pug_debug_filename = "\u002Fopt\u002Fgirder\u002Fgirder\u002Fweb_client\u002Fsrc\u002Ftemplates\u002Fwidgets\u002FrootSelectorWidget.pug";
if (!home || model.id !== home.id) {
;pug_debug_line = 13;pug_debug_filename = "\u002Fopt\u002Fgirder\u002Fgirder\u002Fweb_client\u002Fsrc\u002Ftemplates\u002Fwidgets\u002FrootSelectorWidget.pug";
pug_html = pug_html + "\u003Coption" + (pug.attr("value", model.id, true, true)+pug.attr("data-group", groupName, true, true)+pug.attr("selected", model.id === selected.id, true, true)) + "\u003E";
;pug_debug_line = 13;pug_debug_filename = "\u002Fopt\u002Fgirder\u002Fgirder\u002Fweb_client\u002Fsrc\u002Ftemplates\u002Fwidgets\u002FrootSelectorWidget.pug";
pug_html = pug_html + (pug.escape(null == (pug_interp = format(model)) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Foptgroup\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fselect\u003E";}.call(this,"display" in locals_for_with?locals_for_with.display:typeof display!=="undefined"?display:undefined,"format" in locals_for_with?locals_for_with.format:typeof format!=="undefined"?format:undefined,"groups" in locals_for_with?locals_for_with.groups:typeof groups!=="undefined"?groups:undefined,"home" in locals_for_with?locals_for_with.home:typeof home!=="undefined"?home:undefined,"selected" in locals_for_with?locals_for_with.selected:typeof selected!=="undefined"?selected:undefined));} catch (err) {pug.rethrow(err, pug_debug_filename, pug_debug_line, pug_debug_sources[pug_debug_filename]);};return pug_html;};
module.exports = template;


// WEBPACK FOOTER //
// ./src/templates/widgets/rootSelectorWidget.pug